import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faDotCircle } from "@fortawesome/pro-regular-svg-icons";
import { faCircle as faCircleSolid } from "@fortawesome/pro-solid-svg-icons";
import {
  PermissionKind,
  PERMISSION_FULL,
  PERMISSION_RESTRICTED,
  PERMISSION_NONE,
} from "utils/permissions";

const PermissionIcon: React.FunctionComponent<{
  permission: PermissionKind;
}> = ({ permission }) => {
  switch (permission) {
    case PERMISSION_FULL:
      return (
        <span title="Full">
          <FontAwesomeIcon icon={faCircleSolid} />
        </span>
      );
    case PERMISSION_RESTRICTED:
      return (
        <span title="Restricted">
          <FontAwesomeIcon icon={faDotCircle} />
        </span>
      );
    case PERMISSION_NONE:
      return (
        <span title="None">
          <FontAwesomeIcon icon={faCircle} />
        </span>
      );
  }
};

export default PermissionIcon;
